import { UserOperation } from "../common";

export function validateUserOp(userOp: UserOperation): boolean {
	const errors: string[] = [];

	if (!userOp.sender) {
		errors.push("Sender is required");
	}
	if (!userOp.nonce) {
		errors.push("Nonce is required");
	}
	if (!userOp.callData) {
		errors.push("CallData is required");
	}
	if (!userOp.callGasLimit) {
		errors.push("CallGasLimit is required");
	}
	if (!userOp.verificationGasLimit) {
		errors.push("VerificationGasLimit is required");
	}
	if (!userOp.preVerificationGas) {
		errors.push("PreVerificationGas is required");
	}
	if (!userOp.maxFeePerGas) {
		errors.push("MaxFeePerGas is required");
	}
	if (!userOp.maxPriorityFeePerGas) {
		errors.push("MaxPriorityFeePerGas is required");
	}

	if (errors.length > 0) {
		throw new Error(`Validation failed: ${errors.join(", ")}`);
	}

	return true;
}


